import React, { memo } from "react";

import { Document, Page, Text, View, Font } from "@react-pdf/renderer";

import { withNamespaces } from "react-i18next";

import {
  FONT_OPEN_SANS_BOLD,
  FONT_OPEN_SANS_REGULAR,
} from "src/components/constants";

import DateUtils from "src/services/utils/DateUtils";

import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import FirstPageHeader from "./components/FirstPageHeader";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Sections from "./Sections";
import styles from "./Styles";
import { generateColor } from "./helpers";
import { now } from "moment";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: FONT_OPEN_SANS_REGULAR,
      fontWeight: 400,
      fontStyle: "normal",
    },
    {
      src: FONT_OPEN_SANS_REGULAR,
      fontWeight: 400,
      fontStyle: "italic",
    },
    {
      src: FONT_OPEN_SANS_BOLD,
      fontWeight: 600,
      fontStyle: "normal",
    },
    {
      src: FONT_OPEN_SANS_BOLD,
      fontWeight: 600,
      fontStyle: "italic",
    },
  ],
});

const DNB = (props) => {
  const { t, organization, supplierData, detailsQuery } = props;

  if (!supplierData || !detailsQuery) {
    return (
      <Document>
        <Page size="A4" style={styles.page1}></Page>
      </Document>
    );
  }

  const primaryColor = organization?.primaryColor || "#5664d2";

  const logo = {};

  if (organization.secondaryLogo) {
    logo.src = organization.secondaryLogo;
    logo.size = {
      maxWidth: "200px",
      height: `${organization.secondaryLogoSize || 40}px`,
    };
  } else {
    logo.src = organization.primaryLogo;
    logo.size = {
      maxWidth: "240px",
      maxHeight: "120px",
      height: `${organization.primaryLogoSize || 40}px`,
    };
  }

  const isOwnCompany = !!supplierData.supplierDetail?.isOwnCompany;

  const dateUtils = new DateUtils();

  const renderGeneralInfosSection = () => {
    const supplierDetail = supplierData;

    return (
      <>
        <View style={styles.sections}>
          <View style={styles.generalInfos}>
            <View style={styles.generalInfosRow}>
              <View style={styles.generalInfosRowCol}>
                <Text style={styles.generalInfosTitle}>
                  {t("Company Name")}:
                </Text>
                <Text style={styles.generalInfosValue}>
                  {supplierDetail?.name}
                </Text>
              </View>
              <View style={styles.generalInfosRowCol}>
                <Text style={styles.generalInfosTitle}>
                  {t("Responsible Person")}:
                </Text>
                {props.contactPerson?.length > 0 ? (
                  props.contactPerson.map((person, index) => (
                    <Text
                      key={person.id || index}
                      style={styles.generalInfosValue}
                    >
                      {t(person.title)} {person.name} {person.lastName}
                    </Text>
                  ))
                ) : (
                  <Text style={styles.generalInfosValue}>—</Text>
                )}
              </View>
            </View>

            <View style={styles.generalInfosRow}>
              <View style={styles.generalInfosRowCol}>
                <Text style={styles.generalInfosTitle}>
                  {t("Assigned Analyst")}:
                </Text>
                <Text style={styles.generalInfosValue}>
                  {supplierDetail?.assignedAnalyst && (
                    <>
                      {`${supplierDetail.assignedAnalyst.firsName || ""} ${
                        supplierDetail?.assignedAnalyst?.lastName || ""
                      }`}
                    </>
                  )}
                </Text>
              </View>
              <View style={styles.generalInfosRowCol}>
                <Text style={styles.generalInfosTitle}>
                  {t("Submission Date")}:
                </Text>
                <Text style={styles.generalInfosValue}>
                  {supplierDetail?.creationDate &&
                    dateUtils.convertDateToDate(
                      supplierDetail?.creationDate,
                      INTERNATIONAL_DATE_FORMAT
                    )}
                </Text>
              </View>
            </View>
            <View style={styles.generalInfosRow}>
              <View style={styles.generalInfosRowCol}>
              <Text style={styles.generalInfosTitle}>
                  {t("Report Download Date")}:
                </Text>
                <Text style={styles.generalInfosValue}>
                  {dateUtils.convertDateToDate(
                    now(),
                    INTERNATIONAL_DATE_FORMAT
                  )}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </>
    );
  };

  styles.sectionSeparator.backgroundColor = generateColor(primaryColor, 15);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <FirstPageHeader
          startColor={primaryColor}
          stopColor={generateColor(primaryColor, 15)}
          backgroundColor={primaryColor}
          logo={logo}
          isOwnCompany={isOwnCompany}
          companyName={props?.organization?.name}
        />

        <View>{renderGeneralInfosSection()}</View>

        <Footer backgroundColor={primaryColor} />
      </Page>

      <Page size="A4" style={styles.page}>
        <Header
          startColor={primaryColor}
          stopColor={generateColor(primaryColor, 15)}
          backgroundColor={primaryColor}
          logo={logo}
        />

        <View>
          <Sections
            supplierData={supplierData}
            detailsQuery={detailsQuery}
            noteBackgroundColor={styles.sectionSeparator.backgroundColor}
          />
        </View>

        <Footer backgroundColor={primaryColor} />
      </Page>
    </Document>
  );
};

export default withNamespaces()(DNB);
